export default __webpack_public_path__ + "static/media/web_screen_meetings_ko.1e7ceb26.png";